import { AlertTriangle } from "lucide-react";

// Compact, reusable "not an investment" disclaimer. Use on coin pages + checkout.
export default function RiskDisclaimer({ className = "" }) {
  return (
    <div
      className={`border border-[#2a2a2a] bg-[#121212] px-4 py-3 flex items-start gap-3 ${className}`}
      data-testid="risk-disclaimer"
    >
      <AlertTriangle size={14} className="text-[#ffd700] flex-shrink-0 mt-0.5" />
      <p className="font-mono text-[11px] leading-relaxed text-[#d0d0d0] uppercase tracking-wide">
        Tokens on SolSpur are utility / collectible assets — <span className="text-[#e2e2e2]">not investments</span>.
        No profit, yield, or return is promised. Crypto is volatile and you can lose everything.
        This is not financial advice. Unavailable where prohibited by law.
      </p>
    </div>
  );
}
